(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-announcement-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-announcement-bar')) {
    class CartAnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.slides = [];
        this.currentIndex = 0;
        this.interval = Number.parseInt(this.dataset.interval || '4500', 10);
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.boundAdvance = this.advance.bind(this);
        this.boundPause = this.pause.bind(this);
        this.boundResume = this.resume.bind(this);
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-cart-announcement-slide]'));

        if (this.slides.length <= 1 || this.prefersReducedMotion.matches) {
          return;
        }

        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

        if (this.currentIndex < 0) {
          this.currentIndex = 0;
          this.slides[0].classList.add('is-active');
          this.slides[0].setAttribute('aria-hidden', 'false');
        }

        this.addEventListener('mouseenter', this.boundPause);
        this.addEventListener('mouseleave', this.boundResume);
        this.addEventListener('focusin', this.boundPause);
        this.addEventListener('focusout', this.boundResume);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.removeEventListeners();
      }

      addEventListeners() {
        this.addEventListener('mouseenter', this.boundPause);
        this.addEventListener('mouseleave', this.boundResume);
        this.addEventListener('focusin', this.boundPause);
        this.addEventListener('focusout', this.boundResume);
      }

      removeEventListeners() {
        this.removeEventListener('mouseenter', this.boundPause);
        this.removeEventListener('mouseleave', this.boundResume);
        this.removeEventListener('focusin', this.boundPause);
        this.removeEventListener('focusout', this.boundResume);
      }

      start() {
        if (this.timer || this.slides.length <= 1) {
          return;
        }

        this.timer = window.setInterval(this.boundAdvance, this.interval);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      pause() {
        this.stop();
      }

      resume() {
        if (this.slides.length > 1) {
          this.start();
        }
      }

      advance() {
        if (this.slides.length <= 1) {
          return;
        }

        const nextIndex = (this.currentIndex + 1) % this.slides.length;
        const currentSlide = this.slides[this.currentIndex];
        const nextSlide = this.slides[nextIndex];

        currentSlide.classList.remove('is-active');
        currentSlide.setAttribute('aria-hidden', 'true');

        nextSlide.classList.add('is-active');
        nextSlide.setAttribute('aria-hidden', 'false');

        this.currentIndex = nextIndex;
      }
    }

    customElements.define('cart-announcement-bar', CartAnnouncementBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-coupon-codes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-coupon-codes')) {
    class CartCouponCodes extends HTMLElement {
      connectedCallback() {
        this.boundClick = this.onClick.bind(this);
        this.addEventListener('click', this.boundClick);

        this.boundCartUpdated = (e) => this.updateVisibility(e.detail.cart.item_count);
        document.addEventListener('cart:updated', this.boundCartUpdated);

        this.watchProductsContainer();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.boundClick);
        document.removeEventListener('cart:updated', this.boundCartUpdated);
        if (this.observer) this.observer.disconnect();
      }

      watchProductsContainer() {
        const productsEl = document.querySelector('[data-products]');
        if (!productsEl) return;

        this.syncFromProductsEl(productsEl);

        this.observer = new MutationObserver(() => this.syncFromProductsEl(productsEl));
        this.observer.observe(productsEl, { childList: true });
      }

      syncFromProductsEl(productsEl) {
        const cartItemsEl = productsEl.querySelector('[data-cart-subtotal]');
        if (!cartItemsEl) return;
        this.updateVisibility(parseInt(cartItemsEl.dataset.count, 10) || 0);
      }

      updateVisibility(itemCount) {
        this.hidden = itemCount === 0;
      }

      onClick(event) {
        const button = event.target.closest('[data-cart-coupon-copy]');
        if (!button || !this.contains(button)) return;

        const code = button.dataset.code || '';
        if (!code) return;

        this.copyToClipboard(code, button);
      }

      async copyToClipboard(code, button) {
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
          } else {
            const textarea = document.createElement('textarea');
            textarea.value = code;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            textarea.remove();
          }
          this.showCopied(button);
        } catch (error) {
          console.error('Failed to copy coupon code', error);
        }
      }

      showCopied(button) {
        window.clearTimeout(button._copiedTimeout);
        button.classList.add('is-copied');
        button._copiedTimeout = window.setTimeout(() => {
          button.classList.remove('is-copied');
        }, 1500);
      }
    }

    customElements.define('cart-coupon-codes', CartCouponCodes);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-upsell')) {
    class CartUpsell extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('[data-cart-upsell-track]');
        this.message = this.querySelector('[data-cart-upsell-message]');
        this.details = this.querySelector('[data-cart-upsell-details]');
        this.limit = this.dataset.limit || '4';
        this.sectionId = this.dataset.sectionId || 'cart-drawer-upsell';
        this.recommendationsUrl = this.dataset.recommendationsUrl || '';
        this.defaultButtonText = this.dataset.buttonText || '+ Add';
        this.loading = false;
        this.refreshQueued = false;
        this.refreshForce = false;
        this.currentSignature = '';
        this.currentSeedId = '';
        this.currentState = '';
        this.boundRefresh = this.queueRefresh.bind(this);
        this.boundToggle = this.savePanelState.bind(this);
        this.boundClick = this.onClick.bind(this);
        this.boundMenuClick = this.onMenuClick.bind(this);
        this.boundDocumentClick = this.onDocumentClick.bind(this);
        this.boundKeydown = this.onKeydown.bind(this);
        this.boundViewportChange = this.positionSizeMenu.bind(this);
        this.rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.panelStorageKey = 'cart-upsell-panel-state';
        this.activeSizeControl = null;
        this.activeSizeTrigger = null;
        this.activeSizeMenu = null;
        this.activeSizeMenuInner = null;
      }

      connectedCallback() {
        if (!this.track || !this.recommendationsUrl) {
          this.hide();
          return;
        }

        this.restorePanelState();
        this.addEventListeners();
        this.initSwipe();
        if (this.details) {
          this.details.addEventListener('toggle', this.boundToggle);
        }

        if (this.isCartDrawerOpen()) {
          this.queueRefresh({ type: 'drawerOpen.CartDrawer' });
        }
      }

      disconnectedCallback() {
        this.closeSizeMenu(false);
        this.removeEventListeners();
        this.destroySwipe();
        if (this.details) {
          this.details.removeEventListener('toggle', this.boundToggle);
        }
      }

      addEventListeners() {
        document.addEventListener('drawerOpen.CartDrawer', this.boundRefresh);
        document.addEventListener('ajaxProduct:added', this.boundRefresh);
        document.addEventListener('cart:updated', this.boundRefresh);
        document.addEventListener('click', this.boundDocumentClick);
        document.addEventListener('keydown', this.boundKeydown);
        window.addEventListener('resize', this.boundViewportChange, { passive: true });
        window.addEventListener('scroll', this.boundViewportChange, true);
        this.addEventListener('click', this.boundClick);
      }

      removeEventListeners() {
        document.removeEventListener('drawerOpen.CartDrawer', this.boundRefresh);
        document.removeEventListener('ajaxProduct:added', this.boundRefresh);
        document.removeEventListener('cart:updated', this.boundRefresh);
        document.removeEventListener('click', this.boundDocumentClick);
        document.removeEventListener('keydown', this.boundKeydown);
        window.removeEventListener('resize', this.boundViewportChange);
        window.removeEventListener('scroll', this.boundViewportChange, true);
        this.removeEventListener('click', this.boundClick);
      }

      initSwipe() {
        const track = this.track;
        if (!track) return;

        let isDown = false;
        let startX = 0;
        let startScrollLeft = 0;
        let wasDragged = false;

        track.style.cursor = 'grab';

        this._swipeDown = (e) => {
          if (e.pointerType === 'touch') return;
          if (e.target.closest('a, button, input, select, label, [role="button"]')) return;
          isDown = true;
          wasDragged = false;
          startX = e.clientX;
          startScrollLeft = track.scrollLeft;
          track.style.cursor = 'grabbing';
          track.style.scrollSnapType = 'none';
        };

        this._swipeMove = (e) => {
          if (!isDown || e.pointerType === 'touch') return;
          const dx = startX - e.clientX;
          if (!wasDragged && Math.abs(dx) > 4) {
            wasDragged = true;
            track.setPointerCapture(e.pointerId);
          }
          if (wasDragged) track.scrollLeft = startScrollLeft + dx;
        };

        this._swipeUp = (e) => {
          if (!isDown || e.pointerType === 'touch') return;
          isDown = false;
          track.style.cursor = 'grab';
          track.style.scrollSnapType = '';
          if (wasDragged) {
            const card = track.querySelector('.cart-upsell__card, .cart-upsell__skeleton');
            const snapUnit = (card ? card.offsetWidth : track.offsetWidth) + 12;
            const targetIndex = Math.round(track.scrollLeft / snapUnit);
            track.scrollTo({ left: targetIndex * snapUnit, behavior: 'smooth' });
          }
          wasDragged = false;
        };

        track.addEventListener('pointerdown', this._swipeDown);
        track.addEventListener('pointermove', this._swipeMove);
        track.addEventListener('pointerup', this._swipeUp);
        track.addEventListener('pointercancel', this._swipeUp);
      }

      destroySwipe() {
        const track = this.track;
        if (!track || !this._swipeDown) return;
        track.removeEventListener('pointerdown', this._swipeDown);
        track.removeEventListener('pointermove', this._swipeMove);
        track.removeEventListener('pointerup', this._swipeUp);
        track.removeEventListener('pointercancel', this._swipeUp);
        track.style.cursor = '';
      }

      queueRefresh(event) {
        const isDrawerOpen = this.isCartDrawerOpen();

        if (event && event.detail && event.detail.force) {
          this.refresh(true);
          return;
        }

        if (event && event.type === 'ajaxProduct:added' && event.detail && event.detail.addToCartBtn && event.detail.addToCartBtn.closest('[data-cart-upsell-add]')) {
          this.removeAddedCard(event.detail.addToCartBtn);
          this.refresh(true);
          return;
        }

        if (event && (event.type === 'ajaxProduct:added' || event.type === 'cart:updated') && !isDrawerOpen) {
          return;
        }

        if (this.loading) {
          this.refreshQueued = true;
          this.refreshForce = this.refreshForce || (event && (event.type === 'ajaxProduct:added' || event.type === 'cart:updated') && isDrawerOpen);
          return;
        }

        this.refresh(Boolean(event && (event.type === 'ajaxProduct:added' || event.type === 'cart:updated') && isDrawerOpen));
      }

      async refresh(force = false) {
        if (this.loading) {
          this.refreshQueued = true;
          this.refreshForce = this.refreshForce || force;
          return;
        }

        this.loading = true;
        this.classList.add('is-loading');
        this.clearMessage();

        try {
          const cart = await this.fetchCart();

          if (!cart || !cart.item_count) {
            this.hide();
            return;
          }

          this.removeAttribute('hidden');
          this.currentState = '';
          this.closeSizeMenu(false);

          const seedIds = [...new Set(cart.items.map((item) => String(item.product_id)).filter(Boolean))];
          if (!seedIds.length) {
            this.closeSizeMenu(false);
            this.track.innerHTML = '';
            this.currentSignature = cart.items.map((item) => String(item.product_id)).join('|');
            this.currentSeedId = '';
            this.currentState = 'empty';
            return;
          }

          const cartSignature = cart.items.map((item) => String(item.product_id)).join('|');
          if (!force && this.currentSignature === cartSignature && this.currentState) {
            return;
          }

          const recommendation = await this.findRecommendations(seedIds, cart.items);

          if (!recommendation) {
            this.closeSizeMenu(false);
            this.track.innerHTML = '';
            this.currentSignature = cartSignature;
            this.currentSeedId = '';
            this.currentState = 'empty';
            return;
          }

          this.closeSizeMenu(false);
          this.track.innerHTML = recommendation.html;
          this.currentSignature = cartSignature;
          this.currentSeedId = recommendation.seedId;
          this.currentState = 'loaded';
        } catch (error) {
          this.hide();
          console.error('Cart upsell failed to load', error);
        } finally {
          this.loading = false;
          this.classList.remove('is-loading');

          if (this.refreshQueued) {
            const queuedForce = this.refreshForce;
            this.refreshQueued = false;
            this.refreshForce = false;
            this.refresh(queuedForce);
          }
        }
      }

      async fetchCart() {
        const response = await fetch(`${this.rootPath}cart.js`, {
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('Failed to load cart');
        }

        return response.json();
      }

      async fetchRecommendations(seedId) {
        const cacheKey = `${seedId}:${this.limit}:related`;

        if (CartUpsell.cache.has(cacheKey)) {
          return CartUpsell.cache.get(cacheKey);
        }

        const url = new URL(this.recommendationsUrl, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        url.searchParams.set('product_id', seedId);
        url.searchParams.set('limit', this.limit);
        url.searchParams.set('intent', 'related');

        const response = await fetch(url.toString(), {
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('Failed to load recommendations');
        }

        const html = await response.text();
        CartUpsell.cache.set(cacheKey, html);
        return html;
      }

      async findRecommendations(seedIds, cartItems) {
        for (const seedId of seedIds) {
          const rawHtml = await this.fetchRecommendations(seedId);
          const filteredHtml = this.filterRecommendationHtml(rawHtml, cartItems);

          if (filteredHtml) {
            return {
              html: filteredHtml,
              seedId: seedId
            };
          }
        }

        return null;
      }

      filterRecommendationHtml(html, cartItems) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const container = doc.querySelector('[data-cart-upsell-recommendations]');

        if (!container) {
          return '';
        }

        const cartProductIds = new Set(cartItems.map((item) => String(item.product_id)));
        container.querySelectorAll('[data-product-id]').forEach((card) => {
          if (cartProductIds.has(card.dataset.productId)) {
            card.remove();
          }
        });

        if (!container.children.length) {
          return '';
        }

        return container.innerHTML;
      }

      isCartDrawerOpen() {
        const drawer = this.closest('#CartDrawer');
        return Boolean(drawer && drawer.classList.contains('drawer--is-open'));
      }

      onClick(event) {
        const sizeTrigger = event.target.closest('[data-cart-upsell-size-trigger]');

        if (sizeTrigger && this.contains(sizeTrigger)) {
          event.preventDefault();
          event.stopPropagation();
          this.toggleSizeMenu(sizeTrigger.closest('[data-cart-upsell-size-control]'));
          return;
        }

        const sizeOption = event.target.closest('[data-cart-upsell-size-option]');

        if (sizeOption && this.contains(sizeOption)) {
          event.preventDefault();
          event.stopPropagation();
          this.selectSizeOption(sizeOption);
          return;
        }

        const button = event.target.closest('[data-cart-upsell-add]');

        if (!button || button.disabled || !this.contains(button)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        this.closeSizeMenu(false);
        this.addItem(button);
      }

      removeAddedCard(button) {
        const card = button.closest('.cart-upsell__card');

        if (!card) {
          return;
        }

        if (this.activeSizeControl && card.contains(this.activeSizeControl)) {
          this.closeSizeMenu(false);
        }

        card.remove();

        if (!this.querySelector('.cart-upsell__card')) {
          this.hide();
          return;
        }
      }

      toggleSizeMenu(control) {
        if (!control) {
          return;
        }

        if (this.activeSizeControl === control) {
          this.closeSizeMenu(false);
          return;
        }

        this.openSizeMenu(control);
      }

      openSizeMenu(control) {
        const trigger = control.querySelector('[data-cart-upsell-size-trigger]');
        const menu = control.querySelector('[data-cart-upsell-size-menu]');

        if (!trigger || !menu || !control.querySelector('[data-cart-upsell-size-option]')) {
          return;
        }

        this.closeSizeMenu(false);
        this.activeSizeControl = control;
        this.activeSizeTrigger = trigger;
        this.activeSizeMenu = menu;
        this.activeSizeMenuInner = menu.querySelector('.cart-upsell__size-menu-inner');

        trigger.setAttribute('aria-expanded', 'true');
        const rootStyles = window.getComputedStyle(this);
        menu.style.setProperty('--cart-upsell-button-border', rootStyles.getPropertyValue('--cart-upsell-button-border').trim());
        menu.style.setProperty('--cart-upsell-text', rootStyles.getPropertyValue('--cart-upsell-text').trim());
        menu._cartUpsellControl = control;
        menu._cartUpsellCard = control.closest('.cart-upsell__card');
        menu._cartUpsellOriginalParent = menu.parentNode;
        menu._cartUpsellNextSibling = menu.nextSibling;
        if (document.body && menu.parentNode !== document.body) {
          document.body.appendChild(menu);
        }
        menu.addEventListener('click', this.boundMenuClick);
        menu.hidden = false;
        menu.style.visibility = 'hidden';
        menu.style.overflow = 'hidden';
        if (this.activeSizeMenuInner) {
          this.activeSizeMenuInner.style.overflowY = 'auto';
          this.activeSizeMenuInner.style.scrollbarGutter = 'stable';
        }

        requestAnimationFrame(() => {
          this.positionSizeMenu();

          if (this.activeSizeMenu === menu) {
            menu.style.visibility = '';
          }
        });
      }

      closeSizeMenu(focusTrigger = false) {
        const trigger = this.activeSizeTrigger;
        const menu = this.activeSizeMenu;

        if (!trigger && !menu) {
          return;
        }

        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }

        if (menu) {
          menu.removeEventListener('click', this.boundMenuClick);
          menu.hidden = true;
          menu.style.visibility = '';
          menu.style.left = '';
          menu.style.top = '';
          menu.style.width = '';
          menu.style.maxHeight = '';
          menu.style.overflow = '';
          menu.removeAttribute('data-open-below');
          menu.style.removeProperty('--cart-upsell-button-border');
          menu.style.removeProperty('--cart-upsell-text');

          if (this.activeSizeMenuInner) {
            this.activeSizeMenuInner.style.maxHeight = '';
            this.activeSizeMenuInner.style.overflowY = '';
            this.activeSizeMenuInner.style.scrollbarGutter = '';
          }

          const originalParent = menu._cartUpsellOriginalParent;
          const nextSibling = menu._cartUpsellNextSibling;

          if (originalParent && originalParent.isConnected) {
            if (nextSibling && nextSibling.parentNode === originalParent) {
              originalParent.insertBefore(menu, nextSibling);
            } else {
              originalParent.appendChild(menu);
            }
          } else if (menu.parentNode) {
            menu.parentNode.removeChild(menu);
          }

          menu._cartUpsellOriginalParent = null;
          menu._cartUpsellNextSibling = null;
          menu._cartUpsellControl = null;
          menu._cartUpsellCard = null;
        }

        this.activeSizeControl = null;
        this.activeSizeTrigger = null;
        this.activeSizeMenu = null;
        this.activeSizeMenuInner = null;

        if (focusTrigger && trigger && typeof trigger.focus === 'function') {
          try {
            trigger.focus({ preventScroll: true });
          } catch (error) {
            trigger.focus();
          }
        }
      }

      positionSizeMenu() {
        if (!this.activeSizeControl || !this.activeSizeTrigger || !this.activeSizeMenu || this.activeSizeMenu.hidden) {
          return;
        }

        const triggerRect = this.activeSizeTrigger.getBoundingClientRect();
        const menu = this.activeSizeMenu;
        const menuInner = this.activeSizeMenuInner || menu.querySelector('.cart-upsell__size-menu-inner');
        const viewportPadding = 8;
        const gap = 6;
        const viewportWidth = Math.max(window.innerWidth, 0);
        const viewportHeight = Math.max(window.innerHeight, 0);
        const menuWidth = Math.min(Math.max(Math.round(triggerRect.width), 0), Math.max(viewportWidth - viewportPadding * 2, 0));
        menu.style.width = `${menuWidth}px`;

        const availableBelow = Math.max(0, viewportHeight - triggerRect.bottom - gap - viewportPadding);
        const innerMaxHeight = Math.max(0, Math.floor(availableBelow - 8));

        menu.style.maxHeight = '';
        menu.style.overflow = 'hidden';
        if (menuInner) {
          menuInner.style.maxHeight = `${innerMaxHeight}px`;
          menuInner.style.overflowY = 'auto';
          menuInner.style.scrollbarGutter = 'stable';
        }

        const top = triggerRect.bottom + gap;
        let left = triggerRect.left;
        const maxLeft = viewportWidth - viewportPadding - menuWidth;

        if (left < viewportPadding) {
          left = viewportPadding;
        } else if (left > maxLeft) {
          left = Math.max(viewportPadding, maxLeft);
        }

        menu.style.left = `${Math.round(left)}px`;
        menu.style.top = `${Math.round(top)}px`;
        menu.dataset.openBelow = 'true';
      }

      onMenuClick(event) {
        if (!this.activeSizeMenu || !this.activeSizeMenu.contains(event.target)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const sizeOption = event.target.closest('[data-cart-upsell-size-option]');

        if (sizeOption) {
          this.selectSizeOption(sizeOption);
        }
      }

      selectSizeOption(option) {
        const menu = option.closest('[data-cart-upsell-size-menu]');
        const control = menu && menu._cartUpsellControl ? menu._cartUpsellControl : option.closest('[data-cart-upsell-size-control]');
        const card = menu && menu._cartUpsellCard ? menu._cartUpsellCard : option.closest('.cart-upsell__card');

        if (!control || !card) {
          return;
        }

        const trigger = control.querySelector('[data-cart-upsell-size-trigger]');
        const valueEl = control.querySelector('[data-cart-upsell-size-value]');
        const addButton = card.querySelector('[data-cart-upsell-add]');
        const sizeValue = option.dataset.sizeValue || option.textContent.trim();
        const optionScope = menu || control;

        if (optionScope) {
          optionScope.querySelectorAll('[data-cart-upsell-size-option]').forEach((sizeOption) => {
            const isSelected = sizeOption === option;
            sizeOption.classList.toggle('is-selected', isSelected);
            sizeOption.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          });
        }

        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }

        if (valueEl) {
          valueEl.textContent = sizeValue;
        }

        if (addButton) {
          const variantId = option.dataset.variantId || '';
          addButton.dataset.variantId = variantId;

          if (addButton.getAttribute('aria-busy') !== 'true') {
            addButton.disabled = !variantId;
          }
        }

        this.updateCardPrice(card, option);
        this.closeSizeMenu(true);
      }

      onDocumentClick(event) {
        if (!this.activeSizeControl) {
          return;
        }

        if (this.activeSizeControl.contains(event.target) || (this.activeSizeMenu && this.activeSizeMenu.contains(event.target))) {
          return;
        }

        this.closeSizeMenu(false);
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.activeSizeControl) {
          return;
        }

        this.closeSizeMenu(true);
      }

      updateCardPrice(card, option) {
        const priceEl = card.querySelector('[data-cart-upsell-price-current]');
        const comparePriceEl = card.querySelector('[data-cart-upsell-price-compare]');

        if (!priceEl) {
          return;
        }

        const price = this.parseMoney(option.dataset.variantPrice);
        const comparePrice = this.parseMoney(option.dataset.variantCompareAtPrice);
        const onSale = comparePrice > price;

        priceEl.textContent = this.formatMoney(price);
        priceEl.classList.toggle('cart-upsell__price--sale', onSale);

        if (!comparePriceEl) {
          return;
        }

        if (onSale) {
          comparePriceEl.textContent = this.formatMoney(comparePrice);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.hidden = true;
        }
      }

      parseMoney(value) {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
      }

      formatMoney(value) {
        const moneyFormat = window.theme && window.theme.settings && window.theme.settings.moneyFormat ? window.theme.settings.moneyFormat : '$' + '{' + '{amount}' + '}';

        if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
          return window.theme.Currency.formatMoney(value, moneyFormat);
        }

        return (value / 100).toFixed(2);
      }

      // If this product shares a collection with an item already in the
      // cart that belongs to an active multi-buy-offer "capsule" (one of
      // that widget's own _mbo_* line item properties), carry the same
      // properties forward so the upsell add joins that exact capsule
      // instead of landing as a separate, ungrouped line. Without this,
      // the same product/collection would sometimes group (added via the
      // offer widget) and sometimes not (added via this upsell card),
      // which is the inconsistency this exists to close.
      async findMatchingOfferProperties(card) {
        const collectionIdsAttr = card && card.dataset.collectionIds;

        if (!collectionIdsAttr) {
          return null;
        }

        const productCollectionIds = collectionIdsAttr
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);

        if (!productCollectionIds.length) {
          return null;
        }

        let cart;

        try {
          cart = await this.fetchCart();
        } catch (error) {
          return null;
        }

        const matchingItem = (cart.items || []).find((item) => {
          const props = item.properties || {};
          return props._mbo_offer && productCollectionIds.includes(String(props._mbo_collection_id));
        });

        if (!matchingItem) {
          return null;
        }

        const mboProperties = {};

        Object.keys(matchingItem.properties).forEach((key) => {
          if (key.indexOf('_mbo_') === 0) {
            mboProperties[key] = matchingItem.properties[key];
          }
        });

        return mboProperties;
      }

      async addItem(button) {
        const variantId = button.dataset.variantId;

        if (!variantId) {
          return;
        }

        this.closeSizeMenu(false);

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        this.clearMessage();

        try {
          const card = button.closest('.cart-upsell__card');
          const mboProperties = await this.findMatchingOfferProperties(card);

          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');

          if (mboProperties) {
            Object.keys(mboProperties).forEach((key) => {
              formData.append(`properties[${key}]`, mboProperties[key]);
            });
          }

          const response = await fetch(`${this.rootPath}cart/add.js`, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData,
            credentials: 'same-origin'
          });

          if (!response.ok) {
            let errorPayload = null;

            try {
              errorPayload = await response.json();
            } catch (error) {
            }

            throw errorPayload || new Error('Unable to add item.');
          }

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              addToCartBtn: button
            }
          }));
        } catch (error) {
          this.showMessage(error && (error.description || error.message) ? (error.description || error.message) : 'Unable to add item.');
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }

      hide() {
        this.closeSizeMenu(false);
        this.setAttribute('hidden', '');
        if (this.track) {
          this.track.innerHTML = '';
        }
        this.currentSignature = '';
        this.currentSeedId = '';
        this.currentState = '';
        this.clearMessage();
      }

      restorePanelState() {
        if (!this.details) {
          return;
        }

        try {
          const savedState = window.localStorage.getItem(this.panelStorageKey);
          if (savedState === 'collapsed') {
            this.details.open = false;
          } else if (savedState === 'expanded') {
            this.details.open = true;
          }
        } catch (error) {
        }
      }

      savePanelState() {
        if (!this.details) {
          return;
        }

        try {
          window.localStorage.setItem(this.panelStorageKey, this.details.open ? 'expanded' : 'collapsed');
        } catch (error) {
        }
      }

      showMessage(message) {
        if (!this.message) {
          return;
        }

        this.message.textContent = message;
        this.message.classList.remove('hide');
      }

      clearMessage() {
        if (!this.message) {
          return;
        }

        this.message.textContent = '';
        this.message.classList.add('hide');
      }
    }

    CartUpsell.cache = CartUpsell.cache || new Map();
    customElements.define('cart-upsell', CartUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    getVariantSelectionError() {
      const hasVariantSelectors = this.form.querySelector('[data-product-hot-reload-trigger]') !== null;

      if (!hasVariantSelectors) {
        return null;
      }

      const firstMissingOptionName = this.getFirstMissingVariantOptionName();

      if (firstMissingOptionName) {
        return `Please Select "${firstMissingOptionName}" first.`;
      }

      const variantIdInput = this.form.querySelector('input[name="id"]');
      if (variantIdInput && !variantIdInput.value) {
        return 'Please Select a valid variant.';
      }

      return null;
    }

    getFirstMissingVariantOptionName() {
      const optionGroups = new Map();
      const variantInputs = this.form.querySelectorAll('input[type="radio"][data-product-hot-reload-trigger], select[data-product-hot-reload-trigger]');

      variantInputs.forEach((input) => {
        const groupName = input.name || input.getAttribute('name');
        if (!groupName) return;

        const inputType = input.tagName === 'SELECT' ? 'select' : 'radio';
        const groupKey = `${inputType}:${groupName}`;

        if (!optionGroups.has(groupKey)) {
          optionGroups.set(groupKey, { name: groupName, isSelected: false });
        }

        if (inputType === 'radio' && input.checked) {
          optionGroups.get(groupKey).isSelected = true;
        }

        if (inputType === 'select') {
          const selectedOption = input.options[input.selectedIndex];
          optionGroups.get(groupKey).isSelected = Boolean(selectedOption && selectedOption.dataset.optionValueId);
        }
      });

      for (const optionGroup of optionGroups.values()) {
        if (!optionGroup.isSelected) {
          return optionGroup.name;
        }
      }

      return null;
    }

    dispatchValidationError(message) {
      this.dispatchEvent(
        new CustomEvent('product-form:submit:error', {
          bubbles: true,
          detail: {
            form: this.form,
            cart: null,
            error: {
              message: message
            }
          },
        })
      );
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      const variantSelectionError = this.getVariantSelectionError();
      if (variantSelectionError) {
        this.dispatchValidationError(variantSelectionError);
        return;
      }

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message, 'success');
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message, 'error');
    }

    showMessage(message, state = 'error') {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      this.dataset.state = state;
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');
      this.removeAttribute('data-state');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param only when a concrete variant is selected
      if (this.dataset.variantId) {
        url.searchParams.set('variant', this.dataset.variantId);
      } else {
        url.searchParams.delete('variant');
      }

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-atc')) {
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this._btn = this.querySelector('[data-sticky-atc-btn]');
        this._priceEl = this.querySelector('[data-sticky-atc-price]');
        this._compareEl = this.querySelector('[data-sticky-atc-compare-price]');
        this._variantControl = this.querySelector('[data-sticky-atc-variant-control]');
        this._variantTrigger = this.querySelector('[data-sticky-atc-variant-trigger]');
        this._variantValueEl = this.querySelector('[data-sticky-atc-variant-value]');
        this._variantMenu = this.querySelector('[data-sticky-atc-variant-menu]');
        this._variantOptions = Array.from(this.querySelectorAll('[data-sticky-atc-variant-option]'));
        this._intersectionObserver = null;
        this._mutationObserver = null;
        this._attrObserver = null;
        this._textObserver = null;
        this._contentObserver = null;
        this._mainBtn = null;
        this._menuOpen = false;
        this._syncQueued = false;
        this._boundClick = this._handleClick.bind(this);
        this._boundDocumentClick = this._handleDocumentClick.bind(this);
        this._boundDocumentKeydown = this._handleDocumentKeydown.bind(this);
        this._boundFormChange = this._handleFormChange.bind(this);
        this._boundVariantChange = this._handleVariantChange.bind(this);
        this._selectVariantText = this.dataset.selectVariantText || 'Select options';

        this._initVisibility();
        this._initPriceSync();
        this._initButtonSync();
        this._initClick();
        this._bindLiveObservers();
        this._syncFromForm();
      }

      disconnectedCallback() {
        this._intersectionObserver ?. disconnect();
        this._mutationObserver ?. disconnect();
        this._attrObserver ?. disconnect();
        this._textObserver ?. disconnect();
        this._contentObserver ?. disconnect();
        document.removeEventListener('click', this._boundDocumentClick);
        document.removeEventListener('keydown', this._boundDocumentKeydown);
        document.removeEventListener('variant:change', this._boundVariantChange);
        document.removeEventListener('change', this._boundFormChange, true);
        this.removeEventListener('click', this._boundClick);
      }

      _initVisibility() {
        const target = this._findMainBtn();
        if (! target) return;
        


        this._intersectionObserver ?. disconnect();
        this._intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const show = !entry.isIntersecting;
            this.classList.toggle('is-visible', show);
            this.setAttribute('aria-hidden', String(! show));
          });
        }, {threshold: 0});

        this._intersectionObserver.observe(target);
      }

      _initPriceSync() {
        const scope = this._getPriceScope();
        const mainPrice = scope.querySelector('[data-product-price]');
        const mainCompare = scope.querySelector('[data-compare-price]');
        const mainCompareWrap = scope.querySelector('[data-product-price-wrap]');

        if (! mainPrice || !this._priceEl) return;
        


        const sync = () => {
          this._priceEl.textContent = mainPrice.textContent.trim();

          const isOnSale = mainCompareWrap
            ? ! mainCompareWrap.classList.contains('hide') && mainCompare && mainCompare.textContent.trim() !== ''
            : !!(mainCompare && mainCompare.textContent.trim());

          this._priceEl.classList.toggle('sticky-atc__price--sale', isOnSale);

          if (this._compareEl) {
            if (isOnSale && mainCompare) {
              this._compareEl.textContent = mainCompare.textContent.trim();
              this._compareEl.removeAttribute('hidden');
            } else {
              this._compareEl.textContent = '';
              this._compareEl.setAttribute('hidden', '');
            }
          }
        };

        sync();

        this._mutationObserver ?. disconnect();
        this._mutationObserver = new MutationObserver(sync);
        const textOpts = {
          childList: true,
          characterData: true,
          subtree: true
        };

        this._mutationObserver.observe(mainPrice, textOpts);
        if (mainCompare) 
          this._mutationObserver.observe(mainCompare, textOpts);
        


        if (mainCompareWrap) {
          this._mutationObserver.observe(mainCompareWrap, {
            attributes: true,
            attributeFilter: ['class']
          });
        }
      }

      _initButtonSync() {
        const realBtn = this._findMainBtn();
        if (! realBtn || !this._btn) return;



        this._attrObserver ?. disconnect();
        this._syncButtonState(realBtn);

        this._attrObserver = new MutationObserver(() => {
          this._syncButtonState(realBtn);
        });

        this._attrObserver.observe(realBtn, {
          attributes: true,
          attributeFilter: ['disabled']
        });

        const realBtnText = realBtn.querySelector('[data-add-to-cart-text]');

        if (realBtnText) {
          this._textObserver ?. disconnect();
          this._textObserver = new MutationObserver(() => this._syncButtonState(realBtn));
          this._textObserver.observe(realBtnText, {
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }

      // Mirrors the main Add to cart button's enabled/disabled state and
      // label onto the desktop/tablet sticky button. It stays a genuine
      // disabled button here (unlike mobile) since this bar also carries its
      // own inline size picker.
      _syncButtonState(realBtn) {
        if (! this._btn) return;

        this._btn.disabled = realBtn.disabled;

        const realBtnText = realBtn.querySelector('[data-add-to-cart-text]');

        if (realBtnText) {
          this._btn.textContent = realBtnText.textContent.trim();
        }
      }

      _initClick() {
        if (!this._btn) return;
        


        this.addEventListener('click', this._boundClick);
      }

      _bindLiveObservers() {
        const hotReload = this._findHotReloadRoot();

        if (hotReload) {
          this._contentObserver ?. disconnect();
          this._contentObserver = new MutationObserver(() => {
            this._refreshMainButtonObservers();
            this._queueSyncFromForm();
          });

          this._contentObserver.observe(hotReload, {
            childList: true,
            subtree: true
          });
        }

        document.addEventListener('variant:change', this._boundVariantChange);
        document.addEventListener('change', this._boundFormChange, true);
      }

      _handleFormChange(event) {
        const form = this._findMainForm();
        const target = event.target;

        if (! form || ! target || typeof target.matches !== 'function') {
          return;
        }

        if (! target.matches('[data-variant-input], [data-product-hot-reload-trigger]')) {
          return;
        }

        const targetForm = target.form || (
          typeof target.getAttribute === 'function'
            ? document.getElementById(target.getAttribute('form'))
            : null
        );
        if (targetForm !== form && ! form.contains(target)) {
          return;
        }

        this._queueSyncFromForm();
      }

      _handleVariantChange() {
        this._queueSyncFromForm();
      }

      _refreshMainButtonObservers() {
        const realBtn = this._findMainBtn();

        if (! realBtn || !this._btn) {
          return;
        }

        if (this._mainBtn === realBtn) {
          this._syncButtonState(realBtn);
          return;
        }

        this._mainBtn = realBtn;
        this._initVisibility();
        this._initButtonSync();
      }

      _queueSyncFromForm() {
        if (this._syncQueued) {
          return;
        }

        this._syncQueued = true;

        requestAnimationFrame(() => {
          this._syncQueued = false;
          this._syncFromForm();
        });
      }

      _syncFromForm() {
        this._refreshMainButtonObservers();

        const form = this._findMainForm();
        if (! form || !this._variantOptions.length) {
          return;
        }

        const groups = this._getVariantGroups(form);
        if (! groups.length) {
          return;
        }

        const selectedValues = [];
        let isIncompleteSelection = false;

        for (const group of groups) {
          const value = this._getGroupSelectedValue(group);
          if (! value) {
            isIncompleteSelection = true;
            break;
          }

          selectedValues.push(value);
        }

        if (isIncompleteSelection) {
          this._setSelectedVariant(null);
          return;
        }

        const matchedVariant = this._variantOptions.find((button) => {
          return selectedValues.every((value, index) => button.dataset[`variantOption${
              index + 1
            }`
          ] === value);
        });

        if (! matchedVariant) {
          this._setSelectedVariant(null);
          return;
        }

        this._setSelectedVariant(matchedVariant);
        this._closeVariantMenu(false);
      }

      _getSectionScope() {
        return this._sectionScope || this.closest('.shopify-section') || this;
      }

      _getPriceScope() {
        return this._findHotReloadRoot() || this._getSectionScope();
      }

      _findHotReloadRoot() {
        const form = this._findMainForm();
        return form
          ? form.closest('product-hot-reload')
          : null;
      }

      _findMainBtn() {
        const scope = this._getSectionScope();

        return(scope.querySelector('form.product-single__form [data-add-to-cart]') || scope.querySelector('form[id^="section.flex-pdp.form-"] button[type="submit"]:not([data-sticky-atc-btn])') || document.querySelector('form.product-single__form [data-add-to-cart]') || document.querySelector('form[id^="section.flex-pdp.form-"] button[type="submit"]:not([data-sticky-atc-btn])'));
      }

      _findMainForm() {
        const scope = this._getSectionScope();
        const mainBtn = scope.querySelector('form.product-single__form [data-add-to-cart]') || scope.querySelector('form[id^="section.flex-pdp.form-"] button[type="submit"]:not([data-sticky-atc-btn])') || document.querySelector('form.product-single__form [data-add-to-cart]') || document.querySelector('form[id^="section.flex-pdp.form-"] button[type="submit"]:not([data-sticky-atc-btn])');

        return mainBtn
          ? mainBtn.closest('form')
          : null;
      }

      _getVariantInputs(form) {
        const inputs = Array.from(form.querySelectorAll('[data-variant-input], [data-product-hot-reload-trigger]'));
        const formId = form.getAttribute('id');

        if (! formId) {
          return inputs;
        }

        Array.from(document.querySelectorAll('[data-variant-input], [data-product-hot-reload-trigger]')).forEach((input) => {
          if (input.getAttribute('form') !== formId) {
            return;
          }

          if (! inputs.includes(input)) {
            inputs.push(input);
          }
        });

        return inputs;
      }

      _getVariantGroups(form) {
        const inputs = this._getVariantInputs(form);

        if (! inputs.length) {
          return [];
        }

        const groups = [];
        const seen = new Map();

        inputs.forEach((input, index) => {
          const key = input.dataset.index || `${
            input.tagName
          }:${
            input.name || index
          }`;

          if (! seen.has(key)) {
            const group = {
              key,
              input,
              inputs: []
            };

            seen.set(key, group);
            groups.push(group);
          }

          seen.get(key).inputs.push(input);
        });

        return groups;
      }

      _getGroupSelectedValue(group) {
        const firstInput = group.inputs[0];

        if (! firstInput) {
          return '';
        }

        if (firstInput.tagName === 'SELECT') {
          return firstInput.value || '';
        }

        const selectedInput = group.inputs.find((input) => input.checked);
        return selectedInput
          ? selectedInput.value
          : '';
      }

      _setGroupValue(group, value) {
        const firstInput = group.inputs[0];

        if (! firstInput) {
          return null;
        }

        if (firstInput.tagName === 'SELECT') {
          firstInput.value = value;
          return firstInput;
        }

        const matchingInput = group.inputs.find((input) => input.value === value);

        if (! matchingInput) {
          return null;
        }

        group.inputs.forEach((input) => {
          input.checked = input === matchingInput;
        });

        return matchingInput;
      }

      _setSelectedVariant(button) {
        if (this._variantValueEl) {
          this._variantValueEl.textContent = button
            ? button.dataset.variantTitle || this._selectVariantText
            : this._selectVariantText;
        }

        this._variantOptions.forEach((variantOption) => {
          const isSelected = button
            ? variantOption === button
            : false;
          variantOption.classList.toggle('is-selected', isSelected);
          variantOption.setAttribute(
            'aria-selected',
            isSelected
              ? 'true'
              : 'false'
          );
        });

        if (this._variantTrigger) {
          this._variantTrigger.setAttribute('aria-expanded', 'false');
        }
      }

      _applyVariantSelection(button) {
        const form = this._findMainForm();

        if (! form) {
          return;
        }

        const groups = this._getVariantGroups(form);
        const variantValues = [
          button.dataset.variantOption1 || '',
          button.dataset.variantOption2 || '',
          button.dataset.variantOption3 || ''
        ];

        let triggerInput = null;

        groups.forEach((group, index) => {
          const value = variantValues[index];

          if (! value) {
            return;
          }

          const input = this._setGroupValue(group, value);

          if (! triggerInput && input) {
            triggerInput = input;
          }
        });

        this._setSelectedVariant(button);

        if (triggerInput) {
          triggerInput.dispatchEvent(new Event('change', {bubbles: true}));
        }
      }

      _openVariantMenu() {
        if (!this._variantTrigger || !this._variantMenu || !this._variantOptions.length) {
          return;
        }

        this._menuOpen = true;
        this._variantTrigger.setAttribute('aria-expanded', 'true');
        this._variantMenu.hidden = false;
        document.addEventListener('click', this._boundDocumentClick);
        document.addEventListener('keydown', this._boundDocumentKeydown);

        const selectedOption = this._variantMenu.querySelector('.is-selected, [aria-selected="true"]') || this._variantOptions[0];

        if (selectedOption && typeof selectedOption.focus === 'function') {
          try {
            selectedOption.focus({preventScroll: true});
          } catch (error) {
            selectedOption.focus();
          }
        }
      }

      _closeVariantMenu(focusTrigger = false) {
        if (!this._variantMenu) {
          return;
        }

        this._menuOpen = false;
        this._variantTrigger ?. setAttribute('aria-expanded', 'false');
        this._variantMenu.hidden = true;
        document.removeEventListener('click', this._boundDocumentClick);
        document.removeEventListener('keydown', this._boundDocumentKeydown);

        if (focusTrigger && this._variantTrigger && typeof this._variantTrigger.focus === 'function') {
          try {
            this._variantTrigger.focus({preventScroll: true});
          } catch (error) {
            this._variantTrigger.focus();
          }
        }
      }

      _toggleVariantMenu() {
        if (this._menuOpen) {
          this._closeVariantMenu(false);
        } else {
          this._openVariantMenu();
        }
      }

      _handleDocumentClick(event) {
        if (!this._menuOpen) {
          return;
        }

        if (!this.contains(event.target)) {
          this._closeVariantMenu(false);
          return;
        }

        if (!event.target.closest('[data-sticky-atc-variant-control]')) {
          this._closeVariantMenu(false);
        }
      }

      _handleDocumentKeydown(event) {
        if (!this._menuOpen || event.key !== 'Escape') {
          return;
        }

        event.preventDefault();
        this._closeVariantMenu(true);
      }

      _handleClick(event) {
        const variantTrigger = event.target.closest('[data-sticky-atc-variant-trigger]');

        if (variantTrigger && this.contains(variantTrigger)) {
          event.preventDefault();
          event.stopPropagation();
          this._toggleVariantMenu();
          return;
        }

        const variantOption = event.target.closest('[data-sticky-atc-variant-option]');

        if (variantOption && this.contains(variantOption)) {
          event.preventDefault();
          event.stopPropagation();
          this._applyVariantSelection(variantOption);
          this._closeVariantMenu(true);
          return;
        }

        const button = event.target.closest('[data-sticky-atc-btn]');

        if (! button || !this.contains(button) || button.disabled) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        this._closeVariantMenu(false);

        const realBtn = this._findMainBtn();

        if (! realBtn || realBtn.disabled) {
          return;
        }

        this._submitMainButton(realBtn);
        this._scrollToErrorSoon();
      }

      _submitMainButton(realBtn) {
        const form = realBtn.closest('form');

        if (form && typeof form.requestSubmit === 'function') {
          form.requestSubmit(realBtn);
        } else if (form) {
          realBtn.click();
        } else {
          realBtn.click();
        }
      }

      _scrollToErrorSoon() {
        if (!this._isMobileViewport()) {
          return;
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const errorTarget = this._findErrorTarget();

            if (! errorTarget) {
              return;
            }

            try {
              errorTarget.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
            } catch (error) {
              const top = errorTarget.getBoundingClientRect().top + window.scrollY - 120;
              window.scrollTo({
                top: Math.max(0, top),
                behavior: 'smooth'
              });
            }
          });
        });
      }

      _findErrorTarget() {
        const scope = this._findMainForm() || this._getSectionScope();
        const candidates = [scope.querySelector('[data-product-atc-error]'), scope.querySelector('product-form-messages'), scope.querySelector('.errors')].filter(Boolean);

        return candidates.find((candidate) => {
          if (candidate.hasAttribute('hidden')) {
            return false;
          }

          if (candidate.classList.contains('hide')) {
            return false;
          }

          return candidate.textContent.trim() !== '';
        }) || null;
      }

      _isMobileViewport() {
        return window.matchMedia('(max-width: 639px)').matches;
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-button"] && !Shopify.designMode) return;
  try {
    if (!window.themeVariantPillStockInit) {
    window.themeVariantPillStockInit = true;

    function getVariantValue(variant, index) {
      return variant[index];
    }

    function clearPillMessages(container) {
      container.querySelectorAll('[data-variant-pill-message]').forEach(function(messageEl) {
        messageEl.textContent = '';
        messageEl.hidden = true;
      });
    }

    function getSelectedValuesFromInputs(container) {
      var selectedValues = [];

      container.querySelectorAll('[data-variant-input]').forEach(function(input) {
        var index = input.dataset.index;

        if (!index) {
          return;
        }

        var type = input.getAttribute('type');

        if (type === 'radio' || type === 'checkbox') {
          if (input.checked) {
            selectedValues.push({ value: input.value, index: index });
          }
          return;
        }

        if (input.tagName === 'SELECT') {
          var selectedOption = input.options[input.selectedIndex];
          if (selectedOption && selectedOption.value !== '') {
            selectedValues.push({ value: selectedOption.value, index: index });
          }
          return;
        }

        if (input.value) {
          selectedValues.push({ value: input.value, index: index });
        }
      });

      return selectedValues;
    }

    function findVariant(variants, selections) {
      return variants.find(function(variant) {
        return selections.every(function(selection) {
          return getVariantValue(variant, selection.index) === selection.value;
        });
      });
    }

    function updatePillMessages(container) {
      var stockBlock = container.querySelector('[data-show-variant-stock]');
      var variantJsonEl = container.querySelector('[data-variant-json]');

      if (!stockBlock || !variantJsonEl) {
        return;
      }

      var stockEnabled = stockBlock.dataset.showVariantStock !== 'false';
      var threshold = parseInt(stockBlock.dataset.variantStockThreshold, 10) || 10;

      var variants;
      try {
        variants = JSON.parse(variantJsonEl.textContent);
      } catch (e) {
        return;
      }

      var selectedValues = getSelectedValuesFromInputs(container);
      var optionCount = container.querySelectorAll('.variant-input-wrap').length;

      container.querySelectorAll('.variant-input-wrap').forEach(function(fieldset) {
        var optionIndex = fieldset.dataset.index;

        fieldset.querySelectorAll('.variant-input').forEach(function(pill) {
          var messageEl = pill.querySelector('[data-variant-pill-message]');
          if (!messageEl) {
            return;
          }

          var pillValue = pill.dataset.value;
          var hypotheticalSelections = selectedValues
            .filter(function(selection) { return selection.index !== optionIndex; })
            .concat([{index: optionIndex, value: pillValue}]);

          if (hypotheticalSelections.length !== optionCount) {
            messageEl.textContent = '';
            messageEl.hidden = true;
            return;
          }

          var matchedVariant = findVariant(variants, hypotheticalSelections);
          var soldOutLabel = pill.closest('.variant-wrapper').dataset.soldOutLabel || 'Sold out';

          if (!matchedVariant) {
            messageEl.textContent = '';
            messageEl.hidden = true;
            return;
          }

          if (matchedVariant.available === false) {
            messageEl.textContent = soldOutLabel;
            messageEl.hidden = false;
            return;
          }

          var quantity = matchedVariant.inventory_quantity;
          var isLowStock = stockEnabled
            && matchedVariant.inventory_management === 'shopify'
            && typeof quantity === 'number'
            && quantity > 0
            && quantity <= threshold;

          if (isLowStock) {
            messageEl.textContent = quantity + ' left';
            messageEl.hidden = false;
          } else {
            messageEl.textContent = '';
            messageEl.hidden = true;
          }
        });
      });
    }

    function getPillMessageContainer(target) {
      if (!target || !target.closest) {
        return;
      }

      return target.closest('product-hot-reload, .product-section');
    }

    function schedulePillMessageUpdate(target) {
      var container = getPillMessageContainer(target);

      if (!container) {
        return;
      }

      window.requestAnimationFrame(function() {
        if (container.isConnected) {
          updatePillMessages(container);
        }
      });
    }

    document.addEventListener('change', function(event) {
      var target = event.target;

      if (!target || !target.matches || !target.matches('[data-variant-input]')) {
        return;
      }

      schedulePillMessageUpdate(target);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
